// extracted by mini-css-extract-plugin
export default {"TopTabList":"TopTab_TopTabList__+XbTt","tab":"TopTab_tab__60ShG","active":"TopTab_active__tUWYA","Tablabel":"TopTab_Tablabel__yw-RK"};